var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWrench(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 37,
    viewBox: "-0.30 -0.7 35 37",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.797 13.949c.616 0 1 .708.683 1.264-1.666 2.92-4.7 4.873-8.169 4.873-5.24 0-9.493-4.462-9.526-9.979C15.752 4.567 20.055 0 25.312 0c3.464 0 6.496 1.95 8.163 4.864.32.56-.058 1.273-.678 1.273h-6.956l-2.647 3.906 2.647 3.906h6.956zm-11.355 6.486L8.194 34.401c-1.654 1.744-4.335 1.744-5.988 0-1.654-1.743-1.654-4.569 0-6.312l13.247-13.966c1.07 2.873 3.262 5.185 5.989 6.312zM7.846 30.13c0-.924-.71-1.674-1.588-1.674-.877 0-1.588.75-1.588 1.674 0 .925.711 1.674 1.588 1.674.877 0 1.588-.75 1.588-1.674z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWrench);
export default __webpack_public_path__ + "static/media/wrench.214168c4b053b4b1037f1649b177ebde.svg";
export { ForwardRef as ReactComponent };